import type Stripe from "stripe";

export const getPaymentMethodName = (paymentMethod: Stripe.PaymentMethod) => {
    if (!paymentMethod || !paymentMethod.type) {
        return "unknown";
    }
    if (paymentMethod.type === "card" && paymentMethod.card.wallet) {
        return paymentMethod.card.wallet.type;
    } else {
        return paymentMethod.type;
    }
};
